
<template>
<!-- 项目列表头部导航 -->
    <div class="header-container" :style="headerBg">
        <div class="menu-container clearfix">
            <div class="logo">
                <img v-if="user.company_logo" :src="user.company_logo" alt="">
                <!-- <router-link v-else to="/projectlist"><span class="logo-title">春梅信息</span></router-link> -->
            </div>
            <div style="overflow:hidden;">
                <!-- 切换主题色 -->
                <el-color-picker class="right-menu changeBg" size="small" show-alpha v-model="color1"></el-color-picker>
                <!-- 导航栏右侧 -->
                <el-dropdown class="right-menu" @command="handleLangCommand">
                    <div class="el-dropdown-link">
                        {{$t('lang')}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="cn">
                            中文
                        </el-dropdown-item>
                        <el-dropdown-item command="en">
                            English
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown class="right-menu" @command="handleLogoutCommand">
                    <div class="el-dropdown-link">
                        <i v-if="user.avatar === ''|| user.avatar === undefined" class="el-icon-user-solid"></i>
                        <img v-else :src="user.avatar" alt="" class="avatar" style="padding-left: 8px;">
                        {{user.username}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="userCenter">
                            {{$t('header.userCenter')}}
                        </el-dropdown-item>
                        <el-dropdown-item command="changepassword">
                            {{$t('menu.headchangePassword')}} 
                        </el-dropdown-item>
                        <!-- <el-dropdown-item command="admin" v-if="user.Usertype === 1">
                            {{$t('menu.admin')}} 
                        </el-dropdown-item> -->
                        <el-dropdown-item command="logout">
                            {{$t('header.logout')}}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <div class="right-menu">
                    <!-- <el-badge :value="100" :max="99" class="item">
                        <i class="el-icon-bell"></i>
                    </el-badge> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Storage from '@/utils/storage'
// require("./header.css");

export default {
    name: "TheHeader",
    data() {
        return {
            color1: 'rgb(41, 61, 110)',
        };
    },
    components: {},
    methods: {
        handleLangCommand(command) {
            this.$i18n.locale = command;
            Storage.set("lang", {lang:command});
        },
        handleLogoutCommand(command) {
            switch (command) {
                case "logout":
                    this.handleLogout();
                    break;
                case "userCenter":
                    break;
                // case "admin":
                //     this.$router.push('/admin');
                //     break;
                case "changepassword":
                    this.$router.push('/changepassword');
                    break;
                default:
                    break;
            }
        },
        // 退出登录
        handleLogout() {
            this.$store.dispatch("LogOut").then(()=> {
                // this.$router.push("/login");
                location.href = '/login'
            })
        },
    },
    created() {
        // 获取用户信息
        
    },
    computed: {
        headerBg() {
            return "background-color:"+ this.color1;
        },
        ...mapGetters(["user"])
    },
    
};
</script>

<style scoped>
.header-container {
    flex: 0 0 auto;
    box-shadow: 0 0 3px 0px #ccc;
}
.logo-title{
    line-height: 60px;
    margin: 0 30px;
    font-size: 26px;
    color: #fff;
}
.logo a{
    text-decoration: none;
}
.menu-container .right-menu{
    color: #fff;
}
</style>

 